import { render, staticRenderFns } from "./RepublishingDiscoverStatsTable.vue?vue&type=template&id=698309fb&scoped=true&"
import script from "./RepublishingDiscoverStatsTable.vue?vue&type=script&lang=js&"
export * from "./RepublishingDiscoverStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./RepublishingDiscoverStatsTable.vue?vue&type=style&index=0&id=698309fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698309fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VDataTable,VDialog,VIcon,VTooltip})
